import { render } from "./BannerNotificationItem.vue?vue&type=template&id=3c74182e&scoped=true&ts=true"
import script from "./BannerNotificationItem.vue?vue&type=script&lang=ts"
export * from "./BannerNotificationItem.vue?vue&type=script&lang=ts"

import "./BannerNotificationItem.vue?vue&type=style&index=0&id=3c74182e&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c74182e"]])

export default __exports__